export default __webpack_public_path__ + "static/media/sofa-1-seat-1-back.38979685.webp";